export default __webpack_public_path__ + "static/media/mint-button-clicked.6647143e.gif";